export const CLEAR = "clear";
export const LOADING = "loading";
export const LOADING_MORE = "loading_more";
export const SUCCESS = "success";
export const ERROR = "error";
